

import cyoApiListService from '@/services/api/cyoListApi';
import { encodeURLNew, encodeURL } from '~/utils/helper/cyoHelper';
import { setFilterFromRouteParam, setDefaultFilters } from '~/utils/cyoHelper/cyoFilter.utils';

export default {
    async setupCyoSettingFilter(data) {
        // console.log('setupCyoSettingFilter', data.moduleSubType)
        this.commitMutation('setCyoSettingFilter', data);

        // reset store data on initial load
        this.commitMutation('setCyoSettingFilterOptions', {});
        this.commitMutation('setSettingShowSkeleton', { flag: true });
        this.commitMutation('setSettingListingResults', {
            clearListing: true,
            response: { data: [], total: 0, next_page_url: null },
        });
        // end reset store data on initial load

        
        const callbackFn = async (res) => {
            this.commitMutation('setCyoSettingFilterOptions', res);
            this.setupCyoSettingFilterFromUrl();
            this.setRequestPayload( { unsetStartWith : false });            
            await  this.requestServer({ clearListing : true } )
        }

        try {
            const minMaxPath = cyoApiListService(this).getMinMax( data )
            const useFetchPromise = await $fetch( minMaxPath,{
                method:'GET'
            })
            await callbackFn( useFetchPromise.data  )
        } catch (error) {
            console.log('error', error)
            throw error

        }
    },

    validateCyoSettingCase(){
        const router       = this.getRouterIns()
        const route        = router.currentRoute.value
        if ( !route.meta.moduleType === 'cyo') {
            return
        }
        const cyo          = this.cyoStoreInstance()
        const diamond      = cyo.getDiamond( route.meta.moduleSubType )
        if (diamond) {
            this.requestServer({ clearListing : true })
        }            
    },
    validateCyoDiamondCase( { moduleType, moduleSubType } ){
        if ( moduleType !== 'cyo') {
            return
        }
        const cyo      = this.cyoStoreInstance()
        const setting  = cyo.getSetting( moduleSubType )
        if( setting ){
            this.requestServer({ clearListing : true })
        }
    },

    configureDiamondPayload({ setting }) {
        const payload = this.getRequestPayload();
        let payloadShape = Array.isArray(payload.Shape)
            ? payload.Shape
            : (typeof payload.Shape === 'string' ? payload.Shape.split(',').filter(Boolean) : []);

        // if shapes are absent then set all shapes as per setting available shapes
        if (!payloadShape.length) {
            // either fiery round or shape
            if (payload.FieryRound === 'Yes') {
                delete payload.Shape;
                this.commitMutation('setRequestPayload', payload);
                return false;
            }
            // make first letter caps
            payload.Shape = setting.avail_shapes.map(s => s.charAt(0).toUpperCase() + s.slice(1)).join(',');
            this.commitMutation('setRequestPayload', payload);
            return false;
        }

        // if shapes are present then filter shapes as per setting available shapes     
        payload.Shape = payloadShape.filter(s => setting.avail_shapes.includes(s.toLowerCase()));

        // if shapes are not present then set all shapes as per setting available shapes
        if (!payload.Shape.length) {
            if (payload.FieryRound === 'Yes') {
                delete payload.Shape;
                this.commitMutation('setRequestPayload', payload);
                return false;
            }
            payload.Shape = setting.avail_shapes.map(s => s.charAt(0).toUpperCase() + s.slice(1)).join(',');
        }
        this.commitMutation('setRequestPayload', payload);
        return false;
    },
    setupCyoSettingFilterFromUrl(data) {
        return
    },
    async toggleSettingFilter(data) {
        return
    },
    toggleSettingFilterVisibility(data) {

        this.commitMutation( 'toggleSettingFilterVisibility', data  )
    },
    setRequestPayload( clearListing ){

        const router        = this.getRouterIns()
        const pageType      = this.getSettingListPageType()
        const page          = clearListing ? 1 : this.getSettingListingCurrentPage() + 1
        const filters       = this.getSettingAllFilter()
        const options       = this.getSettingAllFilterOptions()
        const moduleSubType = this.getModuleSubType()
        const urlLabelKeys  = filters && filters.length > 0 ? filters.map(filter => filter.urlLabel) : []
        const routeQuery    = encodeURLNew( router.currentRoute.value.query )
        // filter query Payload by allowed filter keys
        
        const queryPayload = Object.fromEntries(
            Object.entries(routeQuery).filter( ([key]) => 
                urlLabelKeys.includes(key.replace('From', '').replace('To', '') )
            )
        )

        const routeParamPayload = setFilterFromRouteParam(filters, options, router)
        const payload           = { ...routeParamPayload, ...queryPayload, page }
        
        // set path in store for url history
        if( import.meta.client){

            const currentRoute = {...queryPayload}
            delete currentRoute['cyo']
            this.cyoStoreInstance().commitMutation( 'setListingPageUrl', {listingUrl: encodeURL(currentRoute), pageType, moduleSubType} )
        }

        const resultPayload = pageType === 'diamond' ? setDefaultFilters(payload, 99) : payload
        const filterTags = []

        this.commitMutation( 'setRequestPayload', resultPayload )
        this.commitMutation( 'setRequestFilterTags', filterTags )
    },

    setLoader(flag){
        this.commitMutation( 'setSkeletonShowMore', { flag } )
    },

    async requestServer(data){

        this.setRequestPayload( data.clearListing )

        const cyo          = this.cyoStoreInstance()
        const router       = this.getRouterIns()
        const route        = router.currentRoute.value
        const isSalePage   = !!route.meta?.sale


        // ring earring or pendnant
        const moduleType = this.getModuleType()
        const moduleSubType = this.getModuleSubType()

        // setting or diamond
        const pageType = this.getSettingListPageType()

        // cyo diamond setup
        if ( import.meta.client && moduleType === 'cyo' && pageType === 'diamond') {

            const setting  = cyo.getSetting( moduleSubType )
            if( setting ){
                this.configureDiamondPayload( {setting})
            }
        }

        // setup request payload        
        let payload = { ...this.getRequestPayload() }
        
        // change payload as per condition
        if ( moduleType === 'cyo' && pageType === 'setting') {
            payload = { ...payload, Category: moduleSubType }   
        }

        // cyo setting setup
        if ( import.meta.client && moduleType === 'cyo' && pageType === 'setting') {
            const diamond = cyo.getDiamond( moduleSubType )
            if (diamond) {
                // set shape
                if ( diamond.shape) {
                    payload = { ...payload, Shape: ucFirst(diamond.shape)}
                }
                if (diamond.shape_one) {
                    payload = { ...payload, Shape: ucFirst(diamond.shape_one)}
                }
            }            
        }


        // for wedding
        if ( moduleType === 'shop') {

            payload = { ...payload, Subtype: moduleSubType}

            if(isSalePage){
                payload.sale = true
            }

            // custom exception for soiree-cocktail-jewelry
            if(  moduleSubType === 'soiree-cocktail-jewelry' ){

                const filter = this.getSettingFilterOptions( moduleSubType, 'style' )

                // set style as subype
                if( filter?.length > 0 ){
                    
                    payload = { ...payload, Subtype: filter.map(cv => cv.url ).join(',') }
                }
                // if there is user selected style then overwrite it
                if( payload.Style && Array.isArray(payload.Style) && payload.Style.length > 0 ){

                    payload = { ...payload, Subtype: payload.Style.join(',') }
                    
                }

                
            }
            // custom exception for soiree-cocktail-jewelry
            if(  moduleSubType === 'rose-portrait-jewelry' ){

                const filter = this.getSettingFilterOptions( moduleSubType, 'style' )

                // set style as subype
                if( filter?.length > 0 ){
                    
                    payload = { ...payload, Subtype: filter.map(cv => cv.url ).join(',') }
                }
                // if there is user selected style then overwrite it
                if( payload.Style && Array.isArray(payload.Style) && payload.Style.length > 0 ){

                    payload = { ...payload, Subtype: payload.Style.join(',') }
                    
                }
            }
        }
        if (['preset', 'preset-earrings', 'preset-pendant'].includes(moduleType)) {

            payload = { ...payload, Category: moduleType}
        }
         // for gift card
        if ( moduleType === 'gift_card') {

            payload = { ...payload, Subtype: moduleSubType}

        }

        this.commitMutation( 'setShowMoreLoader', { flag : false } )

        const callbackFn = ( res ) => {

            this.commitMutation( 'setSettingListingResults', { ...data, response: res } )
            this.commitMutation( 'setSettingShowSkeleton', { flag : false } )
            this.commitMutation( 'setSkeletonShowMore', { flag : false } )
        }

        if( import.meta.client ){

            if (this.currentController) {
                this.currentController.abort();
            }
        
            this.currentController = new AbortController();
        }

        if (route.query?.ShopTheLookId) {
            payload.ShopTheLookId = route.query.ShopTheLookId
        }

        if (route.query?.newModule) {
            payload.newModule = route.query.newModule
        }
        

        try {
            // Generate the request path
            const reqPath = cyoApiListService().requestProductListApi( {moduleType, moduleSubType, pageType}, payload )

            const requestBody = import.meta.client ? { method: 'GET', signal: this.currentController.signal } : { method: 'GET'}

            // Make the GET request using Axios with the abort signal
            const useFetchPromise = await $fetch( reqPath, requestBody )

            // Pass the response data to the callback function
            await callbackFn( useFetchPromise.data  )

        } catch (error) {

            if (error?.name === 'FetchError' && error?.message?.includes('aborted')) {
                console.debug('Request aborted, skipping...');
                return
            } 
            console.log('error', error)
            throw error
       }
    },
    toggleSettingListingShowMore() {
    },
    async setDiamondCompareListItems( data ){


        let url = ( data.moduleSubType === 'earring' ) ? 'diamond/loose-pair/compare/get' : 'diamond/compare/get'
        
        try {
            const res = await $fetch(useCountryPath(url))
            if(res.data?.length){
                this.commitMutation( 'setDiamondCompareListItems', res )
            }
           
        } catch (error) {
            console.log(error,'error')
            throw error
        }
       
    },

    async setShowMoreLoader(data){
        this.commitMutation( 'setShowMoreLoader', data)
    },
    async setDiamondCompareListCount( data ){


        let url = ( data.moduleSubType === 'earring' ) ?  'diamond/loose-pair/compare/get' : 'diamond/compare/get'
        
        try {
            const res = await $fetch(useCountryPath(url))
            this.commitMutation( 'setDiamondCompareListItems', res )
            if(res?.data && Array.isArray(res?.data) ){
                this.commitMutation( 'setDiamondCompareListCount', res.data.length )
            }
        } catch (error) {
            console.log(error)
            throw error
        }
    },
    markAddOrRemoveFromCompare(data) {
        this.commitMutation( 'markAddOrRemoveFromCompare', data )
    },
    updateListPageCount(){
        console.log('updateListPageCount', this.$state)
    }
}





























// // Define and export the actions function

// import cyoApiListService from '~/services/api/cyoListApi';
// import  productListingHelpers from '~/utils/helper/cyoProductListHelper.js';


// export default function useActions(state, getters, mutation){

//   async function setupCyoSettingFilter(data) {

//     mutation.setupCyoSettingFilter(state, { ...data } )

//     mutation.setSettingListingResults(state, { clearListing: true, response: { data: [], total: 0, next_page_url: null } })

//     const res = await cyoApiListService().getMinMax( data )

//     mutation.setCyoSettingFilterOptions(state, res)
    
//     // console.log('getMinMax 2', res)

    
//     // setupCyoSettingFilterFromUrl( data )
//     // await this.setRequestPayload({ unsetStartWith: false })

//   }


//   function setupCyoSettingFilterFromUrl(data) {

//     // console.log('setupCyoSettingFilterFromUrl', setupCyoSettingFilterFromUrl)
//     productListingHelpers.init( getters, data )

//     // productListingHelpers.setFiltersFromUrl()
//   }

//   return {
//     setupCyoSettingFilter,
//   };
// }
